import { api } from '../lib/api'

export type RelationshipProfileSummary = {
  user_id: number
  profile_id: number
  display_name: string
  handle: string
  avatar_url: string
  public_id: string
}

export type Relationship = {
  id: number
  actor: number
  target: number
  kind: 'follow' | 'block' | 'favorite' | 'mute'
  created_at: string
  target_person?: { id: number; display_name: string | null; avatar_url: string | null } | null
  target_profile?: RelationshipProfileSummary | null
}

export async function listRelationships(kind: Relationship['kind'] = 'block') {
  const { data } = await api.get<Relationship[]>(`/api/relationships/`, { params: { kind } })
  return data
}

export async function blockHandle(handle: string) {
  const { data } = await api.post<Relationship>(`/api/relationships/block-handle/`, { handle })
  return data
}

export async function deleteRelationship(id: number) {
  await api.delete(`/api/relationships/${id}/`)
  return true
}

